export default {
  charactersHidden: "Characters hidden",
  charactersShowing: "Characters showing",
  hidingCharacters: "hiding characters",
  maskLabelText: "Hide",
  unmaskLabelText: "Show"
};